export class ApiError extends Error { constructor(public status: number, message: string) { super(message); } }

export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, { ...init, headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) } });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const b = (await res.json()) as { error?: string }; if (b.error) msg = b.error; } catch { /* keep msg */ }
    throw new ApiError(res.status, msg);
  }
  return (await res.json()) as T;
}
export const post = <T>(path: string, body?: unknown, method = 'POST') => fetchJson<T>(path, { method, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });

export const qs = (params: Record<string, string | number | undefined | null>) => {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  const s = p.toString(); return s ? `?${s}` : '';
};
